import { create } from 'zustand';
import { IEssay } from '../../../core/models/essay';

interface IPracticeEssayState {
  essay: IEssay | null;
  imageURI: string | null;
  setEssay: (essay: IEssay) => void;
  setImage: (uri: string | null) => void;
}

export const practiceEssayStore = create<IPracticeEssayState>((set) => ({
  essay: null,
  imageURI: null,
  setEssay: (essay: IEssay) => set({ essay }),
  setImage: (uri: string | null) => set({ imageURI: uri }),
}));
